<template>
  <div>
    <div v-if="isDetail" class="back-line black-14" @click="isDetail = false"><i class="iconfont icon-fanhui2"></i>返回
    </div>
    <div v-if="!isDetail" class="right-cont">
      <div class="help-nav">
        <div :class="helpNav == item.id ? 'on' : ''" @click="helpNavChange(item.id)" v-for="item in navList" :key="item.id">{{item.name}}</div>
        <!-- <div :class="helpNav == 0 ? 'on' : ''" @click="helpNavChange(0)">账号问题</div>
        <div :class="helpNav == 1 ? 'on' : ''" @click="helpNavChange(1)">咨询问题</div>
        <div :class="helpNav == 2 ? 'on' : ''" @click="helpNavChange(2)">耗材问题</div> -->
      </div>
      <div class="q-warp">
        <div class="q-list" v-for="row in list" @click="goDetail(row)" :key="row.id">
          <div>{{row.title}}</div>
          <div class="iconfont icon-youjiantou"></div>
        </div>
      </div>
    </div>
    <div v-else class="right-cont">
      <div class="d-flex help-detail-top">
        <img class="help-icon" src="../../assets/img/user_center/Q.png" alt="">
        <div class="help-detail-right">
          {{detail ? detail.title : ''}}
        </div>
      </div>
      <div class="d-flex">
        <img class="help-icon" src="../../assets/img/user_center/A.png" alt="">
        <div class="help-detail-right" v-html="detail ? detail.document_content : ''">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { helpCategory, helpList } from "@/http/user_center";

export default {
  name: "help",
  data() {
    return {
      isDetail: false,
      helpNav: "",
      navList: [],
      list: [],
      detail: {}
    };
  },
  created() {
    this.getCategory();
  },
  methods: {
    getCategory() {
      helpCategory().then((res) => {
        this.navList = res.data;
        this.helpNavChange(res.data[0].id);
      });
    },
    getList() {
      helpList({ category_id: this.helpNav }).then((res) => {
        this.list = res.data;
      });
    },
    goDetail(row) {
      this.isDetail = true;
      this.detail = row;
    },
    helpNavChange(i) {
      if (this.helpNav !== i) {
        this.list = [];
      }
      this.helpNav = i;
      this.getList();
    },
  },
};
</script>


<style scoped src="../../assets/css/user_center.css"></style>
